<template>
  <div class="home">
    <h2>Historique des saisies</h2>
    <el-alert
      title="information"
      type="info"
      description="Le suivi conso n'est pas disponible pour l'instant dans cet outils."
      show-icon>
    </el-alert>
    <!-- CI DESSOUS A decommenter -->
    <!-- <el-alert
        title="information"
        type="info"
        description="Vous pouvez consulter l'historique des saisies en
        filtrant par produits et par période."
        show-icon>
      </el-alert>
    <div class="select-container">
      <label>Choisissez un produit : </label>

      <el-select v-model="valueSelected" placeholder="Select">
        <el-option
          v-for="product in listingProducts"
          :key="product.productId"
          :label="product.name"
          :value="product.productId">
        </el-option>
      </el-select>
    </div>
    <div v-loading="loading">
    </div>
    <ListInventory :list="listInventory"/> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import ListInventory from '@/components/Inventory/ListInventory.vue';
import services from 'services';

export default {
  components: {
    // ListInventory,
  },
  async mounted() {
    this.loading = true;
    this.listingProducts = await services.ProductService.getListingProductId();
    const firstProductId = this.listingProducts[0] !== undefined
      ? this.listingProducts[0].productId : null;
    this.valueSelected = firstProductId;
  },
  watch: {
    valueSelected(value) {
      this.loading = true;
      this.$store.dispatch('inventory/fetchInventoryByStore', { productId: value });
      console.log('this.listInventory');
      console.log(this.listInventory);
      this.loading = false;
    },
  },
  computed: {
    listInventory() {
      return this.$store.getters['inventory/listInventory'];
    },
  },
  data() {
    return {
      loading: false,
      listingProducts: [],
      valueSelected: '',
      // valConso: 0,
      // listInventory: [],
      // fakeCustomers: [],
    };
  },
  methods: { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

$margin = 25px;

.select-container
  margin: $margin;

h2
  margin: 15px $margin;

.el-alert {
    margin: $margin;
    width: 80%;
}
</style>
